import { FormArray, FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getFormArray, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { CkNormeValuesEnum } from '../../../common/consts/ckNormeValues.enum';
import { checkCkNormeValueHelper, checkCkNormeValueRequiredHelper, setRequiredIfNormeActiveAndSecondFilledHelper } from '../../../common/helpers/norme-ck-lookup.helper';
import { formArrayRequiredHelper, validaCodiceFiscale } from '../../../common/helpers/norme-validators.helper';

const SPD_PATH = `${formPaths.ammControllo}.my_NormeSpaDualistico`;

export const getNormeSpaDualisticoControl = (form: FormGroup, path: string) => getControl(form, `${SPD_PATH}.${path}`);

export const getAmmControlloGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.ammControllo) as FormGroup;

export const getSpdConsiglioSorveglianzaArray = (form: FormGroup): FormArray => getFormArray(form, `${SPD_PATH}.my_SpdConsiglioSorveglianza.my_SpdElemConsiglioSorveglianza`);

export const getSpdConsiglioGestioneArray = (form: FormGroup): FormArray => getFormArray(form, `${SPD_PATH}.my_SpdConsiglioGestione.my_SpdElemConsiglioGestione`);

export const checkCkNormeValue = (form: FormGroup): boolean => checkCkNormeValueHelper(form, CkNormeValuesEnum.normeSpaDualistico);

export const normeSpaDualisticoCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath = formPaths.ammControllo,
    suppCondition = true,
    errorStatus?: string
): void => checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition && checkCkNormeValue(form), errorStatus);

export const checkCkNormeValueRequired = (form: FormGroup, targetPath: string, subFormPath = formPaths.ammControllo): void =>
    checkCkNormeValueRequiredHelper(form, targetPath, CkNormeValuesEnum.normeSpaDualistico, subFormPath);

export const setRequiredIfNormeActiveAndSecondFilled = (
    form: FormGroup,
    targetPath: string,
    secondFieldPath: string,
    subFormPath = formPaths.ammControllo,
    message?: string
): void => setRequiredIfNormeActiveAndSecondFilledHelper(form, targetPath, secondFieldPath, CkNormeValuesEnum.normeSpaDualistico, subFormPath, message);

export const my_SpdConsiglioSorveglianzaRequiredHelper = (form: FormGroup, targetPath: string): void => {
    formArrayRequiredHelper(getSpdConsiglioSorveglianzaArray(form), targetPath, checkCkNormeValue(form));
};

export const my_SpdConsiglioGestioneRequiredHelper = (form: FormGroup, targetPath: string): void => {
    formArrayRequiredHelper(getSpdConsiglioGestioneArray(form), targetPath, checkCkNormeValue(form));
};

export const codiceFiscaleHelper = (group: FormGroup, nomePath: string, cognomePath: string, codiceFiscalePath: string): void => {
    validaCodiceFiscale(getControl(group, nomePath).value, getControl(group, cognomePath).value, getControl(group, codiceFiscalePath));
};
